import React, { useContext, useMemo } from 'react'
import { SeoItemsTransport } from '../../../transports/home-page-transport'
import { Container, GridContainer, SliderContainer, StyledCarouselProvider, StyledSlider } from './styles'
import { Slide } from 'pure-react-carousel'
import { ScreenContext } from 'react-components'
import RegionColumn from './region-column'

interface Props {
    regions: SeoItemsTransport[]
    columns?: number
    keyPrefix: string
}

export const SeoRegionsGrid = ({ regions, columns = 4, keyPrefix }: Props) => {
    const { isTablet, isDesktop } = useContext(ScreenContext)

    const distributedRegionsByColumn = useMemo(() => {
        return regions.reduce(
            (columnsArray, item, index) => {
                const colIndex = index % columns
                return columnsArray.map((col, idx) => (idx === colIndex ? [...col, item] : col))
            },
            Array.from({ length: columns }, () => [] as SeoItemsTransport[]),
        )
    }, [regions, columns])

    return (
        <Container>
            {isDesktop ? (
                <GridContainer columns={columns}>
                    {distributedRegionsByColumn.map((regions, colIndex) => (
                        <RegionColumn key={`${keyPrefix}-col-${colIndex}`} regions={regions} />
                    ))}
                </GridContainer>
            ) : (
                <SliderContainer>
                    <StyledCarouselProvider
                        totalSlides={distributedRegionsByColumn.length}
                        visibleSlides={isTablet ? 2.5 : 1.1}
                        naturalSlideWidth={1}
                        naturalSlideHeight={1}
                        isIntrinsicHeight
                        lockOnWindowScroll
                        dragStep={1}
                        step={1}
                        center
                    >
                        <StyledSlider $transitionTime={0.3}>
                            {distributedRegionsByColumn.map((regions, colIndex) => (
                                <Slide index={colIndex} key={`${keyPrefix}-slide-${colIndex}`}>
                                    <RegionColumn regions={regions} />
                                </Slide>
                            ))}
                        </StyledSlider>
                    </StyledCarouselProvider>
                </SliderContainer>
            )}
        </Container>
    )
}
